import { useContext } from "react";
import { LookingToContext } from "../context/LookingToContext";

export const handleAddRemove = ({ isComparedIds, setComparedId, id }) => {
  if (isComparedIds.length < 5 || isComparedIds.includes(id)) {
    if (isComparedIds.includes(id)) {
      setComparedId(isComparedIds.filter((listId) => listId !== id));
    } else {
      setComparedId([...isComparedIds, id]);
    }
  } else {
    console.log("You can only compare up to 5 quotes at a time.");
  }
};

export const SORT_LIST = ["rate", "monthlyPayment", "closingCosts"];

export const COMPARE_TOTAL_CLOSING_COST_ITEMS = [
  {
    title: "Lender fees",
    name: "LenderFees",
    subtitles: [
      "Admin Fees",
      "Underwriting",
      "Processing Fees",
      "Hidden Fees",
      "Discount Points",
    ],
  },
  {
    title: "Cannot Shop For",
    name: "CannotShopFor",
    subtitles: [
      "Appraisal Fee",
      "Condo Fees",
      "Attorney Review Fee",
      "Construction Certificate",
    ],
  },
  {
    title: "Can Shop For",
    name: "CanShopFor",
    subtitles: ["Title Fees"],
  },
  {
    title: "Government Fees",
    name: "GovernmentFees",
    subtitles: [
      "Deed Recording Fee",
      "Mortgage Recording Fee",
      "Transfer Taxes",
      "VA Funding Fee",
      "FHA Funding Fee",
      "Government Fees Other",
    ],
  },
  {
    title: "Lender Credit",
    name: "LenderCredit",
    subtitles: [],
  },
];

export const COMPARE_TOTAL_CASH_TO_CLOSE_ITEMS = [
  {
    title: "Primary Items",
    name: "PrimaryItems",
    subtitles: ["Closing Costs", "Down Payment"],
  },
  {
    title: "Prepaids",
    name: "Prepaids",
    subtitles: ["Mortgage Interest", "Homeowners Insurance"],
  },
  {
    title: "Escrows",
    name: "Escrows",
    subtitles: ["Property Taxes", "Homeowners Insurance"],
  },
  {
    title: "Credits",
    name: "Credits",
    subtitles: ["Earnest Money Paid", "Seller/Realtor Credit"],
  },
];

export const sortQuotes = (quotes) => {
  quotes.filter((loan) => {
    const term = loan.loanTerm;
    const type = loan.loanType;
    const amortization = loan.amortizationType;
    const armFixedTermYears = loan.armFixedTermYears;

    return (
      (term === 30 && type === "Conforming" && amortization === "Fixed") ||
      term === 20 ||
      term === 15 ||
      term === 10 ||
      (term === 30 &&
        type === "Conforming" &&
        amortization === "ARM" &&
        [5, 7, 10].includes(armFixedTermYears))
    );
  });
  return quotes;
};

export const isRefinance = () => {
  const lookingTo = useContext(LookingToContext);
  return lookingTo === "Refinance" || lookingTo === "RefinanceAndCashOut";
};
